import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, geti18n } from '../../../utils';
import Input from '../../../components/Input';
import TradeInInput from '../../../components/Input/TradeInInput'
import { calculateTotalUserAmount, getIntelliPriceURL, getUserInputMaxAmount } from '../../../redux/selectors/userAmounts';
import Slider from '../../../components/Slider';
import { updateDownPaymentAction, updateTradeInAction, userAmountsClosedAction, userAmountsOpenedAction, updateTotalPersonalisedAmount } from '../../../redux/actions/userAmounts';
import { getBestOfferActionFromState, restBestOffers } from '../../../redux/actions/bestOffers';
import ImageLink from '../../../components/ImageLink';
import IntelliPriceImage from '../../../assets/intelliprice-logo-grey.png';
import './styles';

/**
 * The UserAmountsPanel displays the location of the user and allows for the Zip Modal
 * to be opened. It also contains the 3 user input areas and displays the total amount
 * that the user has available (Down Payment, Trade In and Retailer Accessories)
 */
class UserAmountsPanel extends Component {
  static propTypes = {
    downPaymentTitle: PropTypes.string,
    downPaymentDisclaimer: PropTypes.string,
    downPaymentValue: PropTypes.number.isRequired,
    downPaymentDispatch: PropTypes.func.isRequired,
    tradeInTitle: PropTypes.string,
    tradeInDisclaimer: PropTypes.string,
    tradeInValue: PropTypes.number.isRequired,
    tradeInDispatch: PropTypes.func.isRequired,
    intelliPriceURL: PropTypes.string.isRequired,
    resetButtonText: PropTypes.string,
    userInputMaxObject: PropTypes.object.isRequired,
    personalizePanelTitle: PropTypes.string,
    bestOffers: PropTypes.func.isRequired, //eslint-disable-line
    resetOffers: PropTypes.func.isRequired,
    panelOpenedDispatch: PropTypes.func.isRequired,
    panelClosedDispatch: PropTypes.func.isRequired,
    totalUserAmountDispatch: PropTypes.func.isRequired
  };
  static defaultProps = {
    title: geti18n('personalizePanel.personalizeTitle'),
    downPaymentTitle: geti18n('personalizePanel.downPayment'),
    downPaymentDisclaimer: geti18n('personalizePanel.downPaymentDisclaimer'),
    tradeInTitle: geti18n('personalizePanel.tradeIn'),
    tradeInDisclaimer: geti18n('personalizePanel.tradeInDisclaimer'),
    resetButtonText: geti18n('personalizePanel.resetButtonText'),
    personalizePanelTitle: geti18n('personalizePanel.personalizeTitle'),
  };
  constructor(props) {
    super(props);
    this.state = {
      downPaymentValue: props.downPaymentValue,
      tradeInValue: props.tradeInValue,
      sticky: '',
      offset: 0
    };
    this.rootSticky = null;
    this.handleDownPayment = this.handleDownPayment.bind(this);
    this.handleTradeIn = this.handleTradeIn.bind(this);
    this.setStickyTop = this.setStickyTop.bind(this);
    this.setOffset = this.setOffset.bind(this);
    this.resetInputs = this.resetInputs.bind(this);
  }
  componentDidMount() {
    this.setOffset();
    window.onresize = this.setOffset;
    window.onscroll = this.setStickyTop;
    this.setStickyTop();
  }
  setOffset() {
    const newState = this.state;
    const browserSize = window.outerWidth ? window.outerWidth : document.body.clientWidth;
    let headerSize = 150;
    if (browserSize < 640) {
      headerSize = 72;
    }
    newState.offset = this.rootSticky.getBoundingClientRect().top + headerSize;
    this.setState(newState);
  }
  setStickyTop() {
    const newState = this.state;
    const st = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop; //eslint-disable-line
    if (st > newState.offset) {
      newState.sticky = 'sticky';
    } else {
      newState.sticky = '';
    }
    this.setState(newState);
  }
  resetInputs() {
    const { resetOffers, bestOffers } = this.props;
    resetOffers();
    bestOffers();
  }
  handleDownPayment(event) {
    const eventType = event.type;
    const suppressTagging = eventType !== 'blur';
    const {
      downPaymentDispatch,
      userInputMaxObject,
      bestOffers,
      tradeInValue,
      downPaymentValue,
      totalUserAmountDispatch
    } = this.props;
    const { downPaymentMax } = userInputMaxObject;
    // TODO: Business logic validation shouldn't be contained at this level.
    // move to the reducer, or the action creator.
    let targetNum = parseInt(event.target.value, 10) || 0; // If non-int value, set to 0
    if (targetNum < 0) targetNum = 0; // Do not allow values less than 0
    const totalAmount = parseInt(tradeInValue, 10) + parseInt(targetNum, 10);
    if (targetNum < downPaymentMax) {
      // setTimeout(function () { //eslint-disable-line
      this.setState({ downPaymentValue: targetNum });
      downPaymentDispatch(targetNum, suppressTagging);
      totalUserAmountDispatch(totalAmount);
      if (targetNum > 99 || targetNum < downPaymentValue) {
        bestOffers();
      }
      // }.bind(this), 500);
    }
  }
  handleTradeIn(event) {
    const eventType = event.type;
    const suppressTagging = eventType !== 'blur';
    const {
      tradeInDispatch,
      userInputMaxObject,
      bestOffers,
      tradeInValue,
      downPaymentValue,
      totalUserAmountDispatch
    } = this.props;
    const { tradeInMax } = userInputMaxObject;
    // TODO: Business logic validation shouldn't be contained at this level.
    // move to the reducer, or the action creator.
    let targetNum = parseInt(event.target.value, 10) || 0; // If non-int value, set to 0
    if (targetNum < 0) targetNum = 0; // Do not allow values less than 0
    const totalAmount = parseInt(downPaymentValue, 10) + parseInt(targetNum, 10);
    if (targetNum < tradeInMax) {
      this.setState({ tradeInValue: targetNum });
      tradeInDispatch(targetNum, suppressTagging);
      totalUserAmountDispatch(totalAmount);
      if (targetNum > 99 || targetNum < tradeInValue) {
        bestOffers();
      }
    }
  }
  render() {
    const { downPaymentTitle,
      downPaymentDisclaimer,
      downPaymentValue,
      tradeInTitle,
      tradeInDisclaimer,
      tradeInValue,
      intelliPriceURL,
      resetButtonText,
      personalizePanelTitle,
      panelOpenedDispatch,
      panelClosedDispatch } = this.props;
    const { sticky } = this.state;
    const containerClasses = `${sticky} personalized-amounts-container margin-bottom-small`;
    const stickyPadding = sticky ? 'sticky-padding personalized-amounts' : 'personalized-amounts';
    return (
      <div id="personalized-amounts" className={stickyPadding}>
        <div ref={(node) => { this.rootSticky = node }} id="personalized-amounts-container" className={containerClasses} >
          <Slider
            visibleChild={personalizePanelTitle}
            openDispatch={panelOpenedDispatch}
            closedDispatch={panelClosedDispatch}
          >
            <div className="pe-personal-panel" >
              <div className="row">
                <div className="columns medium-6 large-6">
                  <div className="personalize-columns">
                    <ImageLink image={IntelliPriceImage} url={intelliPriceURL} classNames="intelliprice-link" linkName="INTELLIPRICE" target="_blank" />
                    <TradeInInput
                      title={tradeInTitle}
                      disclaimerContent={tradeInDisclaimer}
                      value={tradeInValue}
                      handler={this.handleTradeIn}
                      blurHandler={this.handleTradeIn}
                      hasDisclaimer
                      type="number"
                    />
                  </div>
                </div>
                <div className="columns medium-6 large-6">
                  <div className="personalize-columns">
                    <Input
                      title={downPaymentTitle}
                      disclaimerContent={downPaymentDisclaimer}
                      value={downPaymentValue}
                      handler={this.handleDownPayment}
                      blurHandler={this.handleDownPayment}
                      hasDisclaimer
                      type="number"
                    />
                  </div>
                </div>
              </div>
              <div className="reset-button"><a onClick={this.resetInputs} className="reset"> {resetButtonText} </a></div>
            </div>
          </Slider>
        </div>
      </div>

    )
  }
}

/**
 * Update the amounts based on the state, updates the total amount
 * based on those inputs as well.
 * @param state
 */
const mapStateToProps = state => ({
  totalUserAmount: calculateTotalUserAmount(state),
  downPaymentValue: get(state, 'userAmounts.downPayment'),
  tradeInValue: get(state, 'userAmounts.tradeIn'),
  intelliPriceURL: getIntelliPriceURL(state),
  userInputMaxObject: getUserInputMaxAmount(state)
});

const mapDispatchToProps = dispatch => ({
  downPaymentDispatch: bindActionCreators(updateDownPaymentAction, dispatch),
  tradeInDispatch: bindActionCreators(updateTradeInAction, dispatch),
  totalUserAmountDispatch: bindActionCreators(updateTotalPersonalisedAmount, dispatch),
  bestOffers: bindActionCreators(getBestOfferActionFromState, dispatch),
  resetOffers: bindActionCreators(restBestOffers, dispatch),
  panelOpenedDispatch: bindActionCreators(userAmountsOpenedAction, dispatch),
  panelClosedDispatch: bindActionCreators(userAmountsClosedAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserAmountsPanel);



/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/UserAmountsPanel/index.js
 **/